<template>
  <Spinner v-if="loading" />
  <div class="admin-page">
    <Transition>
      <JobModal v-if="selectedJob" :job="selectedJob" @close="selectedJob = false" :users="allUsers"
        @changeUser="changeUser" />
    </Transition>
    <div class="admin-page-inner">
      <div class="admin-page-header">
        <div>
          <h1 class="admin-page-title">Schichtplanung</h1>
        </div>
        <div class="admin-action-bar">
          <button v-if="Object.keys(jobs).length > 0" type="button"
            class="hidden md:inline-block admin-button--secondary"
            @click="exportCSV()">
            CSV Export
          </button>
        </div>
      </div>
      <section class="admin-panel mb-5">
        <div class="admin-panel__body text-left">
          <span class="block text-2xl font-bold">Filter</span>
          <div class="inline-block p-2 relative">
            <span class="block font-bold mt-2">Projekt</span>
            <Autocomplete :list="allProjects.map(el=>el.name)" :value="project"
              @update:value="newProject =>{ project = newProject;getJobs()}" placeholder="Projekt" />
          </div>
          <div class="inline-block p-2">
            <div class="inline-block p-2 acwrapper">
              <span class="block font-bold mt-2">Monat</span>
              <input type="month" v-model="month" class="border-b-2 w-36 border-gray-500" @change="getJobs" />
            </div>
          </div>
          <div class="inline-block p-2">
            <div class="inline-block p-2 acwrapper 2xl:border-l-4 pl-4">
              <span class="block font-bold mt-2">Legende</span>
              <div class="grid md:grid-cols-2 2xl:text-2xl md:text-lg">
                <span><i class="mr-2 fa fa-file-circle-question" />: Zugewiesen,
                  aber nicht angenommen</span>
                <span><i class="mr-2 fa fa-file" />: Zugewiesen und
                  angenommen</span>
                <span><i class="text-green-500 mr-2 fa fa-file-circle-check" />:
                  Bestätigt</span>
                <span><i class="text-green-500 mr-2 fa fa-file-shield" />: Zeit
                  geprüft</span>
                <span><i class="text-green-500 mr-2 fa fa-file-invoice-dollar" />:
                  Bezahlt</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div class="md:hidden mb-4" v-if="Object.keys(jobs).length > 0">
        <button type="button" class="admin-button--secondary" @click="exportCSV()">CSV Export</button>
      </div>
      <div class="text-center">
        <div v-if="mode == 'project'">
          <div v-if="Object.keys(jobs).length > 0" class="w-full">
            <div v-for="place in Object.keys(jobs)" :key="place" class="w-full">
              <span class="inline-block text-2xl font-bold mt-5">{{ place }}</span><br />
              <div v-if="jobs[place].Offen && jobs[place].Offen.length > 0">
                <span class="inline-block font-bold text-xl w-full text-left">Offene Schichten
                  ({{jobs[place].Offen.length}}):</span>
                <table class="w-full overflow-x-auto block md:table mt-2">
                  <thead ref="head">
                    <th>Datum</th>
                    <th>Beginn</th>
                    <th>Ende</th>
                    <th>Einsatzstelle</th>
                    <th>Position</th>
                    <th>Mitarbeiter</th>
                    <th>Aktionen</th>
                  </thead>
                  <tbody ref="body">
                    <tr v-for="job in jobs[place].Offen" :key="job.id">
                      <td>{{ job.datum_formatted }}</td>
                      <td>{{ job.Soll_Von }}</td>
                      <td>{{ job.Soll_Bis }}</td>
                      <td>{{ job.Einsatzstelle_Beschreibung }}</td>
                      <td>{{ job.Pos }}</td>
                      <td>
                        <div>
                          <div class="inline-block p-2 relative">
                            <Autocomplete :list="allUsers.map(el=>el.displayName)" :value="job.Mitarbeiternr"
                              @update:value="newVal =>{ job.Mitarbeiternr = newVal;job.changed=true}"
                              placeholder="Mitarbeiternr" />

                          </div>
                          <button v-if="job.changed" type="button"
                            class="mx-1 mt-4 admin-button--primary admin-button--sm"
                            @click="changeUser(job)">
                            Speichern
                          </button>
                          <button v-if="job.changed" type="button"
                            class="mx-1 mt-4 admin-button--secondary admin-button--sm"
                            @click="getJobs()">
                            Reset
                          </button>
                        </div>
                      </td>
                      <td class="align-top">
                        <button type="button" class="mx-1 mt-4 admin-button--secondary admin-button--sm"
                          @click="selectedJob=job">Details</button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="block overflow-x-auto relative ">
                <span class="inline-block font-bold text-xl w-full text-left">Schichtplan:</span>
                <table class="w-full inline-block origin-top-left ">
                  <thead>
                    <th class="mt-5">Schicht</th>
                    <th>IST-Stunden</th>
                    <th>SOLL-Stunden</th>
                    <th v-for="day in days" :key="day.date">
                      {{ day.weekday }}<br />{{ day.date }}
                    </th>
                  </thead>
                  <tbody>
                    <template v-for="user in sortEmployeeKeys(Object.keys(jobs[place]), jobs[place])" :key="user">
                      <tr v-if="user != 'Offen'">
                        <th class="bg-gray-500 text-white" v-if="jobs[place][user].user">{{jobs[place][user].user.name}} {{jobs[place][user].user.surname}} <br>({{ user }})</th>
                        <th class="bg-gray-500 text-white" v-else>{{user}}</th>
                        <th class="text-center" :class="jobs[place][user].user && jobs[place][user].user.sumhours < jobs[place][user].user.monthlyHours ? 'bg-red-200' : ''">
                        {{jobs[place][user].user ? jobs[place][user].user.sumhours.toFixed(2) : '0.00'}}
                        </th>
                        <th class="text-center">
                          {{jobs[place][user].user ? jobs[place][user].user.monthlyHours.toFixed(2) :  '0.00'}}
                        </th>
                        <td v-for="day in days" :key="day.date" class="text-center hover:bg-gray-200" >
                          <div class="text-center cursor-pointer inline" @click="selectedJob = job" v-for="job in (jobs[place][user].jobs || []).filter((el) => {
                          return (
                            el.Datum_von ==
                            day.obj.toISOString().substring(0, 10)
                          );
                        })" :key="job.id">
                            <i v-if="job.Mitarbeiternr == ''" class="fa fa-file-circle-xmark text-2xl text-red-700" />
                            <i v-else-if="job.Bez" class="fa fa-file-invoice-dollar text-2xl text-green-600" />
                            <i v-else-if="job['Ist_Zeiten_geprüft']"
                              class="fa fa-file-shield text-2xl text-green-600" />
                            <i v-else-if="job['MA_bestätigt']"
                              class="fa fa-file-circle-check text-2xl text-green-600" />
                            <i v-else-if="job.MA_gebucht" class="fa fa-file text-2xl" />
                            <i v-else class="fa fa-file-circle-question text-2xl" />
                            <br>
                            {{job.Soll_Von}}<br>-<br>{{job.Soll_Bis}}
                          </div>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
          <div v-else-if="mode == 'overview'">
            <div class="block overflow-x-auto relative ">
              <span class="inline-block font-bold text-xl w-full text-left">Schichtplan:</span>
              <table class="w-full inline-block origin-top-left ">
                <thead>
                  <th class="mt-5">Name</th>
                  <th>IST-Stunden</th>
                  <th>SOLL-Stunden</th> 
                  <th v-for="day in days" :key="day.date">
                    {{ day.weekday }}<br />{{ day.date }}
                  </th>
                </thead>
                <tbody>
                  <tr v-for="user in sortEmployeeKeys(Object.keys(jobs), jobs)" :key="user">
                    <th class="bg-gray-500 text-white">{{jobs[user].user.name}} {{jobs[user].user.surname}} <br>({{user}})</th>
                    <th class="text-center" :class="jobs[user].user.sumhours < jobs[user].user.monthlyHours ? 'bg-red-200' : ''">{{jobs[user].user.sumhours.toFixed(2)}}</th>
                    <th class="text-center">{{jobs[user].user.monthlyHours.toFixed(2)}}</th>
                    <td v-for="day in days" :key="day.date" class="text-center hover:!bg-gray-200 border border-gray-200">



                      <div class="text-center cursor-pointer border border-gray-300" v-for="job in jobs[user].jobs.filter((el) => {
                        return (
                          el.Datum_von.substring(0, 10) ==
                          day.obj.toISOString().substring(0, 10)
                        );
                      })" :key="job.id">
                        <i v-if="job.Mitarbeiternr == ''" class="fa fa-file-circle-xmark text-2xl text-red-700" />
                        <i v-else-if="job.Bez" class="fa fa-file-invoice-dollar text-2xl text-green-600" />
                        <i v-else-if="job['Ist_Zeiten_geprüft']" class="fa fa-file-shield text-2xl text-green-600" />
                        <i v-else-if="job['MA_bestätigt']" class="fa fa-file-circle-check text-2xl text-green-600" />
                        <i v-else-if="job.MA_gebucht" class="fa fa-file text-2xl" />
                        <i v-else class="fa fa-file-circle-question text-2xl" />
                        <br>
                        {{job.Soll_Von}}<br>-<br>{{job.Soll_Bis}}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div v-else-if="searched">
            <span class="text-xl font-bold mt-10">Keine Aufträge in diesem Monat</span>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
  import CASP from "../../CASP";
  import { useCookies } from "vue3-cookies";
  import JobModal from "@/components/JobModal.vue";
  import Autocomplete from "@/components/Autocomplete";
  import Spinner from "@/components/Spinner";
  import { Sortable } from "sortablejs-vue3";

  export default {
    setup() {
      const { cookies } = useCookies();
      return { cookies };
    },
    name: "Jobs",
    components: { JobModal, Spinner, Autocomplete, Sortable },
    data() {
      return {
        token: "",
        project: "",
        month: new Date().toISOString().split("T")[0].substring(0, 7),
        end: "",
        loading: false,
        allProjects: [],
        console: console,
        allUsers: [],
        showProjectDropdown: false,
        selectedJob: false,
        searched: false,
        drag: false,
        jobs: {},
        days: [],
        jobEmployeeDropdown: "",
        mode: "overview"
      };
    },
    methods: {
      filterUsers(job) {
        this.jobEmployeeDropdown = job.id;
        let options = "";
        this.allUsers.forEach((el) => {
          if (
            el.displayName.toLowerCase().includes(job.Mitarbeiternr.toLowerCase())
          ) {
            options += "<p class='dp'>" + el.displayName + "</p>";
          }
        });
        if (this.$refs["jobDropdown" + job.id]) {
          this.$refs["jobDropdown" + job.id][0].innerHTML = options;
        }
      },
      exportCSV() {
        Object.keys(this.jobs).forEach(key => {
          let place = this.jobs[key]
          let head = document.getElementsByTagName("THEAD")[0].childNodes
          let text = "Schicht;"
          this.getDays()
          this.days.forEach(day => {
            text += day.date + ";"
          })
          text += "\n"
          Object.keys(place).forEach(user => {
            if (user == "Offen") return
            text += user + ";"
            this.days.forEach(day => {
              place[user].forEach(job => {
                if (job.Datum_von == day.obj.toISOString().substring(0, 11) + '00:00:00') {
                  if (job.Mitarbeiternr) {
                    text += job.Soll_Von + " - " + job.Soll_Bis
                  } else {
                    text += "?"
                  }
                }
              })
              text += ";"

            })
            text += "\n"
          })
          CASP.createXlsxFromCsv(text, (status, res)=>{
          let element = document.createElement('a');
          element.setAttribute('href', res.xlsx);
          element.setAttribute('download', new Date().toJSON().split("T")[0] + "_" + key + ".xlsx");
          element.style.display = 'none';
          document.body.appendChild(element);
          element.click();
          document.body.removeChild(element);
          })
        })

      },
      getDays() {
        let daysInMonth = new Date(
          this.month.split("-")[0],
          parseInt(this.month.split("-")[1]) + 1,
          0
        ).getDate();
        let days = [];
        for (let i = 1; i <= daysInMonth; i++) {
          let d = new Date(
            this.month.split("-")[0],
            this.month.split("-")[1] - 1,
            i
          );
          d.setHours(5)
          days.push({
            weekday: d.toLocaleDateString("de-DE", { weekday: "short" }),
            date: (i < 10 ? "0" : "") + i + "." + this.month.split("-")[1],
            obj: d,
          });
        }
        this.days = days;
      },

      changeCheckin(job) {
        this.changeJob(job, { checkinRequired: job.checkinRequired });
      },
      changeUser(job) {
        this.selectedJob = false;
        this.changeJob(job, { Mitarbeiternr: job.Mitarbeiternr.split(" (")[0] });
      },
      changeJob(job, changes) {
        CASP.changeJob(this.token, job.id, changes, (res) => {
          if (res) {
            this.getJobs();
          }
        });
      },
      getProjects() {
        let vm = this;
        CASP.getProjects(this.token, (res) => {
          if (res) {
            vm.allProjects = res;
            if (res.length == 1) {
              this.project = res[0].name;
              this.getJobs();
            }
          }
        });
      },
      hideInitialSpinner() {
        const spinner = document.getElementById("mainspinner");
        if (spinner) spinner.style.display = "none";
      },
      getUsers() {
        let vm = this;
        CASP.getUsers(this.token, (res) => {
          if (res) {
            vm.allUsers = res;
          }
        });
      },

      filterProjects() {
        this.showProjectDropdown = true;
        let options = "";
        this.allProjects.forEach((el) => {
          if (el.name.toLowerCase().includes(this.project.toLowerCase())) {
            options += "<p class='dp'>" + el.name + "</p>";
          }
        });
        if (this.$refs.projectList) {
          this.$refs.projectList.innerHTML = options;
        }
      },
      getJobs() {
        this.getDays();
        let vm = this;
        if (this.project) {
          this.mode = "project"
          this.loading = true;
          this.jobs = {};
          CASP.getPlanJobs(
            this.token,
            { project: this.project, month: this.month },
            (res) => {
              vm.jobs = res;
              vm.searched = true;
              vm.loading = false;
            }
          );
        } else {
          this.mode = "overview"
          this.loading = true;
          this.jobs = {};
          // For overview mode, get all jobs but render progressively
          CASP.getPlanJobs(
            this.token,
            { project: this.project, month: this.month },
            (res) => {
              vm.searched = true;
              vm.loading = false;
              // Get all user keys and process them progressively
              const userKeys = Object.keys(res);
              if (userKeys.length > 0) {
                vm.processUsersProgressively(res, userKeys, 0);
              } else {
                vm.jobs = res; // Empty result
              }
            }
          );
        }
      },
      
      processUsersProgressively(allJobs, userKeys, currentIndex) {
        // Base case: we've processed all users
        if (currentIndex >= userKeys.length) {
          return;
        }
        
        // Get current user key
        const userKey = userKeys[currentIndex];
        
        // Add this user to the jobs object
        this.jobs[userKey] = allJobs[userKey];
        
        // Schedule next user to be added after a short delay
        // This allows the DOM to update and keeps the UI responsive
        setTimeout(() => {
          this.processUsersProgressively(allJobs, userKeys, currentIndex + 1);
        }, 1); // Small delay between adding each user
      },

      sortEmployeeKeys(userKeys, jobsData) {
        // Backend now handles filtering and sorting by persnr
        return userKeys;
      },
    },
    computed: {
      today: function () {
        let d = new Date().toISOString().split("T")[0].split("-");
        return d[2] + "." + d[1] + "." + d[0];
      },
      datestamp: function () {
        return new Date().toISOString().split("T")[0] + "00:00:00";
      },
    },
    created: function () {
      this.hideInitialSpinner();
      if (this.cookies.get("caspauth") || this.cookies.get("authtoken")) {
        this.token = this.cookies.get("caspauth") || this.cookies.get("authtoken");
        CASP.isAuthenticated(this.token, (auth) => {
          if (!auth) {
            window.location = "/admin/login";
          } else {
            this.getProjects();
            this.getUsers();
            this.getJobs();
          }
        });
      } else {
        window.location = "/admin/login";
      }
      this.filterProjects();
    },
    mounted() {
      this.hideInitialSpinner();
    },
  };
</script>